import React, { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import { useNavigate,useSearchParams } from 'react-router-dom'; // Assuming react-router-dom is used for navigation
import URL from '../constants/ServerUrl';
import apiConnector from '../utils/axios';
import SkeletonLoader from './Skeletos';

const AddFarmer = ({ route }) => {
  const [searchParams] = useSearchParams();
  const username = searchParams.get('username');

  const [search, setSearch] = useState('');
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedFarmer, setSelectedFarmer] = useState(null);
  const navigate = useNavigate();


  const [farmerData, setFarmerData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const token = localStorage.getItem("dairy-token")

  const fetchData = async () => {
    try {
      if (username) {
        setIsLoading(true);
        const response = await apiConnector("GET", `admin/${username}/farmer`, {}, {
          Authorization: `Bearer ${token}`,
        })
        setIsLoading(false);
        setFarmerData(response.data);
      }
    } catch (error) {
      setIsLoading(false);
      console.log(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const deleteFarmer = async (farmerId) => {
    try {
      if (username) {
        const res = await axios.delete(`${URL}admin/${username}/farmer/${farmerId}`);
        alert('Farmer Deleted Successfully');
        setModalVisible(false);
        fetchData();
      }
    } catch (error) {
      console.warn(error);
    }
  };

  const Item = ({ farmerId, farmerName, farmerLevel, mobileNumber, id }) => (
    <div className="border border-gray-300 rounded-lg p-4 mb-4 flex items-center justify-between">
    <div className="flex items-center">
      <p className="text-xl font-semibold text-gray-800 mr-4">{farmerId}</p>
      <div>
        <p className="text-lg font-bold text-gray-900">{farmerName}</p>
        <p className="text-gray-600">{mobileNumber}</p>
      </div>
    </div>
    <div className="flex items-center">
      <p className="text-lg text-gray-700">Level {farmerLevel}</p>
      <button
        className="bg-red-500 text-white px-3 py-1 rounded-full ml-4 hover:bg-red-600 focus:outline-none focus:bg-red-600"
        onClick={() => {
          navigate(`EditFarmerDetails?username=${username}&farmerId=${farmerId}`)
        }}
      >
        Edit
      </button>
      <button
        className="bg-red-500 text-white px-3 py-1 rounded-full ml-2 hover:bg-red-600 focus:outline-none focus:bg-red-600"
        onClick={() => {
          setSelectedFarmer({ farmerId, id, farmerName });
          setModalVisible(true);
        }}
      >
        Delete
      </button>
    </div>
  </div>
  
  );

  return (
    <div className="container mx-auto p-4">
    <div className="flex justify-between items-center mb-4">
      <input
        type="text"
        placeholder="Search by farmer name"
        onChange={(e) => setSearch(e.target.value)}
        value={search}
        className="flex-grow border border-gray-300 p-2 mr-2"
      />
      <button
        className="bg-green-500 text-white px-4 py-2 rounded"
        onClick={() => navigate(`AddFarmerDetails?username=${username}`)}
      >
        Add Farmer
      </button>
    </div>
  
    {isLoading ? (
      <SkeletonLoader />
    ) : farmerData.length === 0 ? (
      <p className="text-xl">No Farmers Found</p>
    ) : (
      farmerData
        .filter(({ farmerName }) => farmerName.toLowerCase().startsWith(search.toLowerCase()))
        .map((item) => (
          <Item
            key={item._id}
            farmerId={item.farmerId}
            farmerName={item.farmerName}
            farmerLevel={item.farmerLevel}
            mobileNumber={item.mobileNumber}
            id={item._id}
          />
        ))
    )}
  
    {modalVisible && (
      <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
        <div className="bg-white p-4 rounded">
          <p className="text-xl mb-2">Confirm Delete?</p>
          <p>{`Farmer Name: ${selectedFarmer?.farmerName}`}</p>
          <div className="mt-4">
            <button
              className="bg-gray-500 text-white px-2 py-1 rounded mr-2"
              onClick={() => setModalVisible(false)}
            >
              Cancel
            </button>
            <button
              className="bg-red-500 text-white px-2 py-1 rounded"
              onClick={() => deleteFarmer(selectedFarmer?.farmerId)}
            >
              Delete
            </button>
          </div>
        </div>
      </div>
    )}
  </div>
  
  );
};

export default AddFarmer;
